import uiActionsTrackingV2 from 'apis/v2/tracking/uiActions';
import coreTrackingV2 from 'apis/v2/tracking/core';
import assets from 'apis/assets';

const pearClient = {
  v2: {
    tracking: {
      ...uiActionsTrackingV2,
      ...coreTrackingV2,
    },
  },
  assets: {
    fetchCombinedModuleSummaries: assets.fetchCombinedModuleSummaries,
    fetchFullModuleContent: assets.fetchFullModuleContent,
  },
};

export default pearClient;
